//Please add the language resource
const driver = {

  msg:{
  }
};
export default driver



// WEBPACK FOOTER //
// ./src/page/md/driver/lang/driver.en.js